export default function card({ variables }) {
    return {
        MuiCard: {
            defaultProps: {
                elevation: 0,
                variant: "outlined",
            },
            styleOverrides: {
                root: {
                    borderRadius: variables.border_radius_small,
                    border: `1px solid ${variables.border_subtle}`,
                    backgroundColor: variables.surface,
                    backgroundImage: "none",
                    overflow: "hidden",
                },
            },
        },
        MuiCardHeader: {
            styleOverrides: {
                root: {
                    padding: `${variables.spacing_03} ${variables.spacing_04}`,
                    borderBottom: `1px solid ${variables.border_subtle}`,
                },
                title: {
                    fontSize: variables.type_label_font_size,
                    fontWeight: variables.font_weight_semibold,
                    lineHeight: 1.35,
                },
                subheader: {
                    fontSize: variables.type_caption_font_size,
                    color: variables.text_medium,
                },
            },
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    padding: variables.spacing_04,
                    "&:last-child": {
                        paddingBottom: variables.spacing_04,
                    },
                },
            },
        },
        MuiCardActions: {
            styleOverrides: {
                root: {
                    padding: `${variables.spacing_03} ${variables.spacing_04}`,
                },
            },
        },
        MuiCardActionArea: {
            styleOverrides: {
                root: {
                    "&:hover": {
                        backgroundColor: variables.surface_hover,
                    },
                    "& .MuiCardActionArea-focusHighlight": {
                        backgroundColor: "transparent",
                    },
                },
            },
        },
    };
}
//# sourceMappingURL=card.js.map